export const capMultiSelectLimit = (
  limit: number | undefined,
  optionCount: number
) => (limit && optionCount ? Math.min(limit, optionCount) : limit);
